@if (message) {
  <div
    class="comment-container"
    [class.unread]="!message.isRead"
    [class.sent]="editEnable"
  >
    <div class="top">
      <div class="top-left">
        <div class="sent-sontainer">
          @if (!editEnable) {
            <p class="to">From:</p>
            <p class="sender">{{ getDealerName(message.emailAddress) }}</p>
          } @else {
            <p class="to">Sent to:</p>
            @if (message.memberEmails.length + 1 === allDealers.length) {
              <p class="all">ALL</p>
            } @else {
              <p class="recipient-1">
                {{ getDealerName(message.memberEmails[0]) }}
              </p>
              @if (message.memberEmails.length > 1) {
                <p class="recipients" [attr.data-title]="getOtherRecipients()">
                  +{{ message.memberEmails.length - 1 }}
                </p>
              }
            }
          }
        </div>
        <p class="subject">{{ message.subject }}</p>
      </div>
      <div class="top-right">
        <p class="time">{{ getLocalDate() }}</p>
        @if (editEnable) {
          <div class="menu-container" #menu>
            <div class="menu-icon" (click)="toggleMenu()">
              <img src="assets/images/three-dots.svg" alt="menu" />
            </div>
            @if (showMenu) {
              <ul class="comment-menu">
                <!-- Edit disabled as per the requirement -->
                <!-- <li (click)="editComment()">Edit</li> -->
                <li (click)="deleteComment(message.commentId)">Delete</li>
              </ul>
            }
          </div>
        }
      </div>
    </div>
    <div class="comment-content">
      <p class="message">{{ message.commentText }}</p>
      @if (showType) {
        <p class="type">{{ message.commentType }}</p>
      }
    </div>
  </div>
}
